import { Component, Input } from '@angular/core';

@Component({
	selector: 'add-round-btn',
	template: require('./add-round-btn.html')
})
export class AddRoundBtnComponent {
	@Input() isActive: boolean;
	@Input() linkHref: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/add-round-btn/add-round-btn.ts